import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '../ui/card';
import { Modal } from '../ui/modal';

interface NewEstimateModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCreateEstimate: (title: string, description: string) => void;
}

const NewEstimateModal: React.FC<NewEstimateModalProps> = ({ 
  isOpen, 
  onClose, 
  onCreateEstimate 
}) => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!title.trim()) {
      setError('Please enter a title for your estimate');
      return;
    }
    
    onCreateEstimate(title, description);
    handleClose();
  };
  
  const handleClose = () => {
    setTitle('');
    setDescription('');
    setError('');
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <Card className="w-full max-w-md mx-auto">
        <CardHeader>
          <CardTitle>Create New Estimate</CardTitle>
          <CardDescription>
            Give your estimate a title and optional description
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-4">
                {error}
              </div>
            )}
            <div>
              <label htmlFor="estimateTitle" className="block text-sm font-medium mb-1">
                Title*
              </label>
              <input
                type="text"
                id="estimateTitle"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                className="w-full p-2 border rounded-md text-foreground bg-background"
                placeholder="My New Estimate"
                autoFocus
                required
              />
            </div>
            <div>
              <label htmlFor="estimateDescription" className="block text-sm font-medium mb-1">
                Description (optional)
              </label>
              <textarea
                id="estimateDescription"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className="w-full p-2 border rounded-md text-foreground bg-background"
                rows={3}
                placeholder="Brief description of this estimate"
              />
            </div>
            <div className="flex justify-end gap-2 pt-2">
              <Button type="button" variant="outline" onClick={handleClose}>
                Cancel
              </Button>
              <Button type="submit">
                Create Estimate
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </Modal>
  );
};

export default NewEstimateModal; 